import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavigationShareService {
  private state: Record<string, any> = {};

  setState(key: string, value: any): void {
    this.state[key] = value;
  }

  getState(key: string): any {
    return this.state[key];
  }

  clearState(key: string): void {
    delete this.state[key];
  }

  clearAllStates(): void {
    this.state = {};
  }
}
